import { IndicatorReport } from "~/schemas/generated/graphql";
import { getFormatDate } from "~/libs/getFormatDate";
import { TFunction } from "i18next";

export const tableDataFormatter = (data: IndicatorReport[], t: TFunction) => {
  if (!data) {
    return [];
  }
  return data.map((el) => ({
    ...el,
    createdByUser: el.createdByUser?.fullname,
    writtenByUser: el.writtenByUser?.fullname,
    createdAt: getFormatDate(el.createdAt, true),
    updatedAt: getFormatDate(el.updatedAt, true),
  }));
};
